module.exports = __webpack_public_path__ + "static/Quicksand-SemiBold-9e7757030c60a7a6973c9a95d9cea1c0.ttf";